import React from 'react'
import styled from 'styled-components'
import { Text } from 'sutra/components/Text/Text'
import { Toggle } from 'sutra/components/Toggle/Toggle'
import { gray } from 'sutra/tokens/colors'
import { spacing } from 'sutra/tokens/spacing'
import { typography } from 'sutra/tokens/typography'

export interface PermissionsSectionProps {
  emailNotifications: boolean
  onEmailNotificationsChange: (value: boolean) => void
}

/** Renders only the "email me findings" toggle today — Team access /
 * externally-synced-issue permissions from the Linear reference mock have no
 * equivalent concept in this agent model yet. Callers gate whether this
 * section renders at all (Reports agents have no notification preference;
 * Issue agents gate it on the `issue_agent_email_digest` flag). Title +
 * caption + flex-end toggle mirrors the same reference's row shape (its
 * "Team access" / "Externally synced issues and comments" rows). */
export const PermissionsSection: React.FC<PermissionsSectionProps> = ({
  emailNotifications,
  onEmailNotificationsChange,
}) => (
  <Row>
    <TextBlock>
      <Title>Send me findings</Title>
      <Text $size="sm" as="span">
        Email me this agent&apos;s findings after each run
      </Text>
    </TextBlock>
    <Toggle
      checked={emailNotifications}
      onChange={onEmailNotificationsChange}
      aria-label="Email me this agent's findings after each run"
    />
  </Row>
)

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]}px;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const Title = styled.span`
  font-family: ${typography.fontFamily};
  font-size: 13px;
  font-weight: ${typography.weights.semibold};
  color: ${gray[900]};
`
